<div [formGroup]="parentFormGroup">
  <finxone-select-dropdown
    id="address-state"
    [formControlName]="parentFormControlName"
    [label]="label"
    [options]="states"
    [optionLabelKey]="'name'"
    [optionValueKey]="'state_code'"
    [appendToBody]="true"
    [selectedOption]="resolvedSelectedState?.name ?? ''"
    (selectionChange)="onStateSelectionChange($event)"
  >
  </finxone-select-dropdown>
</div>
